<template>
  <div class="white lighten-4">
    <v-container style="max-width: 1800px" class="py-0">
      <v-toolbar elevation="0" class="white">
        <v-toolbar-items>
          <v-btn
            link
            text
            :to="`/project/${$route.params.projectId}/reports/accounting`"
            >{{ $t('market.accounting_document') }}</v-btn
          >
        </v-toolbar-items>
        <v-toolbar-items>
          <v-btn
            link
            text
            :to="`/project/${$route.params.projectId}/reports/market`"
            >{{ $t('market.market_report') }}</v-btn
          >
        </v-toolbar-items>
        <v-toolbar-items>
          <v-btn
            link
            text
            :to="`/project/${$route.params.projectId}/reports/overall`"
            >{{ $t('project.summary', { title: '' }) }}</v-btn
          >
        </v-toolbar-items>
        <!-- <v-toolbar-items
          v-if="role == 'admin' && project.digitalMeterData"
        >
          <v-btn
            link
            text
            :to="`/project/${$route.params.projectId}/reports/digitalmeter`"
            >มิเตอร์ดิจิทัลไฟฟ้า</v-btn
          >
        </v-toolbar-items> -->
      </v-toolbar>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
			projectId: this.$route.params.projectId,
      project: null,
      role: null
    }
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    }
  },
  created(){
    if(this.admins?.length){
      this.project = this.admins[0].project
      this.role = "admin"
    }
    if(this.employees?.length){
      this.project = this.employees[0].project
      this.role = "employee"
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn--text {
  color: #888 !important;
}
.v-btn--active {
  color: #000 !important;
  background-color: white !important;
  border-bottom: 3px solid #00a650;
}
.v-btn:before {
  background-color: white !important;
}
.v-btn {
  padding: 1rem;
}
</style>
